import { useSelector } from 'react-redux';
import { DateTime } from 'luxon';
import { getInitalChartType, getSideDrawerOpen, getViewedAdvancedGraphs } from '../redux/modules/app';
import { getLoginFlowIsComplete } from '../redux/modules/unsavedApp';
import notifications from '../config/notifications.json';

const useSideDrawerOpen = () => useSelector(getSideDrawerOpen);

const useInitialChartType = () => useSelector(getInitalChartType);

const useLoginFlowIsComplete = () => useSelector(getLoginFlowIsComplete);

const useViewAdvancedGraphs = () => useSelector(getViewedAdvancedGraphs);

const useCurrentLocalNotification = () => {
  const currentNotifications = notifications.filter(notification => {
    const startDate = DateTime.fromISO(notification.startDate);
    const endDate = DateTime.fromISO(notification.endDate);
    const now = DateTime.local();

    return startDate <= now && endDate >= now;
  });

  if (currentNotifications.length > 0) {
    return currentNotifications.map(notification => {
      return { message: notification.text, type: 'local' };
    });
  }

  return null;
};

export { useCurrentLocalNotification, useInitialChartType, useLoginFlowIsComplete, useSideDrawerOpen, useViewAdvancedGraphs };
